import Head from "next/head";
import { make as PatreonPage } from "../src/patreon/PatreonPage.bs";

export default function Player() {
  return <PatreonPage />;
}
